import React from "react"
import { BuilderBlockWithBlockId, Form } from "sharedTypes"
import FormContainer from "../../FormManagement/SelectedForm/FormContainer/FormContainer"

type Props = {
  form: Form
  portalPrimaryColor: string
}

const DummyForm = ({ form, portalPrimaryColor }: Props) => {
  const { formData: { blocks } } = form

  const formattedBlocks = blocks.map(
    (block, index) => ({ block, blockId: index } as BuilderBlockWithBlockId),
  )

  return (
    <FormContainer
      form={form}
      blocks={formattedBlocks}
      setBlocks={() => {}}
      onDeleteBlock={() => {}}
      onDuplicateBlock={() => {}}
      formHeaderIsSeparate={false}
      portalPrimaryColor={portalPrimaryColor}
    />
  )
}

export default DummyForm
